import OpenBoxSVG from './OpenBoxSVG'
import TruckSVG from './TruckSVG'
import HoursSVG from './HoursSVG'
import DeliverySVG from './DeliverySVG'
import ProcessingSVG from './ProcessingSVG'
import WarehouseSVG from './WarehouseSVG'
import RestockingSVG from './RestockingSVG'
import DistributionSVG from './DistributionSVG'
import HandlingSVG from './HandlingSVG'
import MonitoringSVG from './MonitoringSVG'
import SupportSVG from './SupportSVG'
import ClockSVG from './ClockSVG'
import PaperCheckSVG from './PaperCheckSVG'
import SignedPaperSVG from './SignedPaperSVG'
import MoneySVG from './MoneySVG'
import DeliveryTruckSVG from './DeliveryTruckSVG'
import PaperChecklistSVG from './PaperChecklistSVG'
import LaptopSVG from './LaptopSVG'
import GraphSVG from './GraphSVG'
import InventoryCenterSVG from './InventoryCenterSVG'
import BoxSVG from './BoxSVG'
import CartSVG from './CartSVG'
import HalfArrowSVG from './HalfArrowSVG'

export const getIcon = icon => {
  switch (icon) {
    case 'OpenBoxSVG':
      return <OpenBoxSVG />
    case 'TruckSVG':
      return <TruckSVG />
    case 'HoursSVG':
      return <HoursSVG />
    case 'DeliverySVG':
      return <DeliverySVG />
    case 'ProcessingSVG':
      return <ProcessingSVG />
    case 'WarehouseSVG':
      return <WarehouseSVG />
    case 'RestockingSVG':
      return <RestockingSVG />
    case 'DistributionSVG':
      return <DistributionSVG />
    case 'HandlingSVG':
      return <HandlingSVG />
    case 'MonitoringSVG':
      return <MonitoringSVG />
    case 'SupportSVG':
      return <SupportSVG />
    case 'ClockSVG':
      return <ClockSVG />
    case 'PaperCheckSVG':
      return <PaperCheckSVG />
    case 'SignedPaperSVG':
      return <SignedPaperSVG />
    case 'MoneySVG':
      return <MoneySVG />
    case 'DeliveryTruckSVG':
      return <DeliveryTruckSVG />
    case 'PaperChecklistSVG':
      return <PaperChecklistSVG />
    case 'LaptopSVG':
      return <LaptopSVG />
    case 'GraphSVG':
      return <GraphSVG />
    case 'InventoryCenterSVG':
      return <InventoryCenterSVG />
    case 'BoxSVG':
      return <BoxSVG />
    case 'CartSVG':
      return <CartSVG />
    case 'HalfArrowSVG':
      return <HalfArrowSVG />
    default:
      return <div>Unknown Icon</div>
  }
}
